var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInfoIcon = function SvgInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 13,
    rx: 6.5,
    stroke: "#2576FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.002 4.004c-.408 0-.72-.3-.72-.696 0-.396.312-.696.72-.696.396 0 .72.3.72.696 0 .396-.324.696-.72.696Zm.552 1.392V11H6.462V5.396h1.092Z",
    fill: "#2576FF"
  })));
};

export default SvgInfoIcon;